// Single source of truth for Season 3 content, shared by every page design.
import alteracPass from '../assets/maps/alterac-pass.jpg'
import battlefieldOfEternity from '../assets/maps/battlefield-of-eternity.jpg'
import hauntedMines from '../assets/maps/haunted-mines.jpg'
import cursedHollow from '../assets/maps/cursed-hollow.jpg'
import dragonShire from '../assets/maps/dragon-shire.jpg'
import gardenOfTerror from '../assets/maps/garden-of-terror.jpg'
import infernalShrines from '../assets/maps/infernal-shrines.jpg'
import skyTemple from '../assets/maps/sky-temple.jpg'
import tombOfTheSpiderQueen from '../assets/maps/tomb-of-the-spider-queen.jpg'
import towersOfDoom from '../assets/maps/towers-of-doom.jpg'
import warheadJunction from '../assets/maps/warhead-junction.jpg'
import fundraising from './fundraising.json'

export const REGISTER_URL = 'https://play.toornament.com/en_US/tournaments/2581691725558089727/'
export const DISCORD_URL = 'https://discord.gg/YdAuTFzfH8'
export const CROWDFUNDING_URL = 'https://gofund.me/ac3a1878b'
export const KOFI_URL = 'https://ko-fi.com/nintorii'
export const RULES_URL = 'https://docs.google.com/document/d/1KdaUZqB4f2PBZknnNruAfZIc1F1rcaCxI06FbOs3oAw/edit?usp=sharing'

export const PAST_SEASONS = [
  { label: 'HCC S1', href: 'https://liquipedia.net/heroes/Heroes_Captains_Clash' },
  { label: 'HCC S2 (EU)', href: 'https://liquipedia.net/heroes/Heroes_Captains_Clash_Europe' },
  {
    label: 'HCC NA vs EU Showmatch',
    href: 'https://liquipedia.net/heroes/Heroes_10_EU_Cup#:~:text=4-,EU%20vs%20NA%20Showmatch,-%5Bedit%5D',
  },
]

// Prize pool = guaranteed base + whatever the GoFundMe has raised
// (snapshotted at build time by scripts/fetch-fundraising.js).
export const PRIZE_POOL_BASE = 250
export const FUNDRAISED = fundraising.raised || 0
export const FUNDRAISED_AT = fundraising.fetchedAt
export const PRIZE_POOL_TOTAL = PRIZE_POOL_BASE + FUNDRAISED
export const formatUSD = (amount) =>
  amount.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: amount % 1 ? 2 : 0,
    maximumFractionDigits: 2,
  })
export const PRIZE_POOL = formatUSD(PRIZE_POOL_TOTAL)
export const PRIZE_SPLIT = [
  { place: '1st', percent: 55 },
  { place: '2nd', percent: 30 },
  { place: '3rd', percent: 15 },
]
export const FORMAT = 'DOUBLE ELIM'
export const SERVER = 'NA-CENTRAL'

export const SCHEDULE_RANGE = 'OCTOBER 5–18, 2026'
export const SCHEDULE_NOTE = 'October 2026 · All tournament matches hosted on NA-central.'
export const REGISTRATION_NOTE = 'Register and view tournament details on Toornament.'

// Calendar runs Monday Oct 5 through Sunday Oct 18.
export const CALENDAR_DAYS = Array.from({ length: 14 }, (_, i) => 5 + i)
export const WEEKDAYS = ['MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT', 'SUN']

// `times` are the published strings; `start` is the same instant in UTC
// (10am PDT = 1pm EDT = 19:00 CEST = 17:00 UTC).
export const PLAY_DAYS = [
  { day: 10, times: ['10am PT/1pm ET', '1900 CEST'], start: '2026-10-10T17:00:00Z' },
  { day: 11, times: ['10am PT/1pm ET', '1900 CEST'], start: '2026-10-11T17:00:00Z' },
  { day: 17, times: ['10am PT/1pm ET', '1900 CEST'], start: '2026-10-17T17:00:00Z' },
  { day: 18, times: ['10am PT', '1900 CEST'], start: '2026-10-18T17:00:00Z' },
]

// Alphabetical.
export const MAPS = [
  { name: 'Alterac Pass', img: alteracPass },
  { name: 'Battlefield of Eternity', img: battlefieldOfEternity },
  { name: 'Cursed Hollow', img: cursedHollow },
  { name: 'Dragon Shire', img: dragonShire },
  { name: 'Garden of Terror', img: gardenOfTerror },
  { name: 'Haunted Mines', img: hauntedMines },
  { name: 'Infernal Shrines', img: infernalShrines },
  { name: 'Sky Temple', img: skyTemple },
  { name: 'Tomb of the Spider Queen', img: tombOfTheSpiderQueen },
  { name: 'Towers of Doom', img: towersOfDoom },
  { name: 'Warhead Junction', img: warheadJunction },
]
